import { AccountForChildProductBullets } from '@components/account-for-child-product-bullets/account-for-child-product-bullets';

export const AccountForChildProductBulletsWidget = () => <AccountForChildProductBullets />;
